<template>
  <div>
    <div class="categorias m-b">Abertura de Embalagem</div>

    <div class="items-row-img">
      <div class="img-exp">
          <!-- Condicional de Fotos  -->
        <div v-if="data.IMG_EMB_EXT != null" class="conteudo">
          <img :src="this.$store.state.ImgURL+data.IMG_EMB_EXT+'.webp'" alt="Não Aplicável" />
        </div>
          <div v-else class="conteudo">
          Não Aplicável
        </div>
        <!--  -->
        <div class="legenda">Embalagem externa</div>
      </div>
      <div class="img-exp">
         <!-- Condicional de Fotos  -->
        <div v-if="data.IMG_EMB_INT != null" class="conteudo">
          <img :src="this.$store.state.ImgURL+data.IMG_EMB_INT+'.webp'" alt="Não Aplicável" />
        </div>
          <div v-else class="conteudo">
            Não Aplicável
        </div>
        <!--  -->
        <div class="legenda">Embalagem interna</div>
      </div>

      <div class="img-exp">
         <!-- Condicional de Fotos  -->
        <div v-if="data.IMG_EMB_EXTRA != null" class="conteudo">
          <img :src="this.$store.state.ImgURL+data.IMG_EMB_EXTRA+'.webp'" alt="Não Aplicável" />
        </div>
          <div v-else class="conteudo">
            Não Aplicável
        </div>
        <!--  -->
        <div class="legenda" v-if="!data.IMG_EMB_EXTRA_DESC">Imagem Extra</div>
          <div class="legenda" v-else>{{data.IMG_EMB_EXTRA_DESC}}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
props : {
  data : Object,
}

};
</script>

<style>
.m-b{
    margin-bottom: 0.5rem;
}

</style>